export function defaultVimeoOptions() {
  return {
    responsive: true,
    byline: false,
    dnt: true,
    title: false,
    playsinline: false,
  };
}
